import { Formik } from "formik";
import { YUPValidations } from "./helper";
import { useEffect, useState } from "react";
import {
  MandatoryStar,
  getSnackbarSuccess,
  isLoadingAction,
} from "../../../../Utils/helper";
import { useDispatch } from "react-redux";
import {
  addProviderSKUPackageAction,
  getProvidersTestListAction,
  getSKUPackageDetailByIdAction,
  getSkuPackagesAction,
} from "../../../../redux/actions/TestPackagesAction";
import Select from "react-select";
import { clearCurrentPage } from "../../../NetworkPortal/ProviderProfileDetails/helper";
import { useLocation } from "react-router-dom";

export const AddQuicklyPackageSKUPopup = ({
  userDetail,
  providerPackageMapStgId,
  setIsAddSku,
  providerPackageId,
  setProviderPackageMapStgId,
  setProviderPackageId,
  searchFilter,
  apiParams,
  packageId,
  setPackageId,
}) => {
  const dispatch = useDispatch();
  const location = useLocation()
  let source = location?.search.split("=")[1]
  const [data, setData] = useState(null);
  const [packageTestList, setPackageTestList] = useState(null);
  const [globalTestDetailsList, setGlobalTestDetailsList] = useState([]);

  useEffect(() => {
    const temp = packageId === null ? 0 : packageId;
    const resp = dispatch(getProvidersTestListAction(temp, 0));
    resp.then((res) => {
      setPackageTestList(res?.data?.results?.lstProviderTest);
      setGlobalTestDetailsList(res?.data?.results?.lstGlobalTestDetails);
    });
  }, []);

  useEffect(() => {
    if (providerPackageMapStgId !== null) {
      const resp = dispatch(
        getSKUPackageDetailByIdAction(
          providerPackageMapStgId,
          providerPackageId
        )
      );
      resp.then((res) => {
        setData(res?.data?.results);
      });
    }
  }, [providerPackageMapStgId]);

  const handleClose = async () => {
    setIsAddSku(false);
    setProviderPackageMapStgId(null);
    setProviderPackageId(null);
    setData(null);
    setPackageId(null);
    await dispatch(getSkuPackagesAction({ ...searchFilter, ...apiParams }));
  };
  const getTestValues = (providerSKUTestIds) => {
    const arr = providerSKUTestIds?.split(",")?.map((ele) => +ele);
    const res = packageTestList?.filter(({ providerTestId }) =>
      arr?.includes(providerTestId)
    );
    const temp = res?.map((ele) => {
      return {
        value: ele?.providerTestId,
        label: ele?.providerTestName,
      };
    });
    return temp;
  };
  return (
    <>
      <div
        className="d-flex justify-content-between border-bottom modalHeader"
        style={{ borderRadius: "10px 10px 0px 0px" }}
      >
        <h4 className="font-bold text-black">
          {providerPackageMapStgId === null
            ? "Add Product Package Creation"
            : "Edit Product Package Creation"}
        </h4>
        <button
          type="button"
          className="btn-close history-close"
          aria-label="Close"
          onClick={handleClose}
        ></button>
      </div>
      <Formik
        enableReinitialize={true}
        initialValues={{ ...data }}
        onSubmit={async (values) => {
          const temp = {
            ...values,
            mrp: values?.mrp,
            walkInPrice: values?.walkInPrice,
            providerPackageMapStgId:
              providerPackageMapStgId === null
                ? 0
                : values?.providerPackageMapStgId,
            packageId: packageId,
            providerPackageId: providerPackageId,
          };
          const resp = dispatch(addProviderSKUPackageAction(source === "WhatsApp" || source === "Email"? {...temp,source:source}: temp));
          resp.then((res) => {
            isLoadingAction(true, dispatch);
            if (res?.data?.status === true) {
              clearCurrentPage(dispatch);
              getSnackbarSuccess("success", res?.data?.message, dispatch);
              isLoadingAction(false, dispatch);
              handleClose();
            } else {
              getSnackbarSuccess("error", res?.data?.message, dispatch);
              isLoadingAction(false, dispatch);
            }
          });
        }}
        validationSchema={YUPValidations}
      >
        {(props) => {
          const { values, errors, handleChange, handleSubmit, setFieldValue } =
            props;
          return (
            <form className="form-admin" onSubmit={handleSubmit}>
              <div className="modal-body addusermodalbox">
                {providerPackageMapStgId !== null && (
                  <p>
                    <label className="col-form-label">
                      HA Package Name:&nbsp;
                    </label>
                    <label className="col-form-label">
                      {userDetail?.haPackageName}
                    </label>
                  </p>
                )}
                <div className="row">
                  <div className="col-lg-4 col-md-4">
                    <label htmlFor=" Role" className="col-form-label">
                      Centre Package Code
                      <MandatoryStar />
                    </label>
                    <input
                      name="centrePackageCode"
                      type="text"
                      placeholder="Centre Package Code"
                      className="form-control form-select-admin inputbgavanish"
                      value={values?.centrePackageCode}
                      onChange={handleChange}
                    />
                    <div className="errorInputMessage">
                      {errors?.centrePackageCode}
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label htmlFor="User Type" className="col-form-label">
                      Centre Package Name
                      <MandatoryStar />
                    </label>
                    <input
                      name="centrePackageName"
                      type="text"
                      placeholder="Centre Package Name"
                      className="form-control form-select-admin inputbgavanish"
                      value={values?.centrePackageName}
                      onChange={handleChange}
                    />
                    <div className="errorInputMessage">
                      {errors?.centrePackageName}
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label htmlFor=" Role" className="col-form-label">
                      MRP (Rs.)
                      <MandatoryStar />
                    </label>
                    <input
                      name="mrp"
                      type="number"
                      step="0.01"
                      presicion={2}
                      onKeyDown={(e) => {
                        if (e.key === " " || e.key === "-" || e.key === "+") {
                          e.preventDefault(); // Prevent entering a space, minus sign, or plus sign
                        }
                      }}
                      placeholder="MRP"
                      className="form-control form-select-admin inputbgavanish"
                      value={values?.mrp}
                      onChange={handleChange}
                    />
                    <div className="errorInputMessage">{errors?.mrp}</div>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label htmlFor=" Role" className="col-form-label">
                      Walk In Price
                      <MandatoryStar />
                    </label>
                    <input
                      name="walkInPrice"
                      type="number"
                      step="0.01"
                      presicion={2}
                      onKeyDown={(e) => {
                        if (e.key === " " || e.key === "-" || e.key === "+") {
                          e.preventDefault(); // Prevent entering a space, minus sign, or plus sign
                        }
                      }}
                      placeholder="Walk In Price"
                      className="form-control form-select-admin inputbgavanish"
                      value={values?.walkInPrice}
                      onChange={handleChange}
                    />
                    <div className="errorInputMessage">
                      {errors?.walkInPrice}
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label htmlFor=" Role" className="col-form-label">
                      Gender
                      <MandatoryStar />
                    </label>
                    <select
                      name="gender"
                      className="form-select form-select-admin"
                      value={values?.gender}
                      onChange={handleChange}
                    >
                      <option value="">Select Gender</option>
                      <option value="M">Male</option>
                      <option value="F">Female</option>
                      <option value="B">Both</option>
                    </select>
                    <div className="errorInputMessage">{errors?.gender}</div>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label htmlFor=" Role" className="col-form-label">
                      Fasting Required
                      <MandatoryStar />
                    </label>
                    <select
                      name="fastingRequired"
                      className="form-select form-select-admin"
                      value={values?.fastingRequired}
                      onChange={(e) => {
                        setFieldValue(
                          "fastingRequired",
                          e.target.value === "true"
                            ? true
                            : e.target.value === "false"
                            ? false
                            : e.target.value
                        );
                      }}
                    >
                      <option value="">Select</option>
                      <option value={true}>Yes</option>
                      <option value={false}>No</option>
                    </select>
                    <div className="errorInputMessage">
                      {errors?.fastingRequired}
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label htmlFor=" Role" className="col-form-label">
                      Visit Type
                      <MandatoryStar />
                    </label>
                    <select
                      name="visitType"
                      className="form-select form-select-admin"
                      value={values?.visitType}
                      onChange={(e) => {
                        setFieldValue("visitType", e.target.value);
                      }}
                    >
                      <option value="">Select Visit Type</option>
                      <option value="HV">Home Visit</option>
                      <option value="DC"> Centre Visit</option>
                    </select>
                    <div className="errorInputMessage">{errors?.visitType}</div>
                  </div>
                </div>
                <div className="row" style={{ padding: "12px" }}>
                  <div className="search-test-div">
                    {/* <Select
                      placeholder="Search Tests & Scans"
                      options={packageTestList?.map((ele) => {
                        return {
                          value: ele?.providerTestId,
                          label: ele?.providerTestName,
                        };
                      })}
                      value={getTestValues(values?.providerSKUTestIds)}
                      isMulti
                        closeMenuOnSelect={false}
                      classNamePrefix="select"
                      name="colors"
                      isClearable={true}
                      onChange={(e) => {
                        setFieldValue(
                          "providerSKUTestIds",
                          e?.map((ele) => ele.value)?.toString()
                        );
                      }}
                    /> */}
                    <div className="globaltest">
                      {globalTestDetailsList?.map((ele) => {
                        return (
                          <div>
                            <button
                              type="button"
                              className={`${
                                ele?.isMapped
                                  ? "globaltest-true"
                                  : "globaltest-false"
                              }`}
                            >
                              {ele?.globalTestName}
                            </button>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
                {(userDetail?.requestStatus === "Rejected" ||
                  userDetail?.requestStatus === "Accepted") &&
                  data?.remarks && (
                    <div className="remarks mt-4">
                      <h5 className="font-bold text-black bottom-spacing-20 mb-3">
                        Remarks
                      </h5>
                      <textarea
                        className="textarea textareaConfirmation font-medium"
                        style={{ height: "130px" }}
                        placeholder="Type Something Here..."
                        value={data?.remarks}
                        disabled={true}
                      ></textarea>
                    </div>
                  )}
              </div>
              <div className="modal-footer modal-footer-admin accept-reject-btns bottom-0  mt-4">
                <button type="submit" className="savedetails">
                  <img
                    style={{ marginRight: "6px" }}
                    src={
                      window.location.pathname.includes("campaigns")
                        ? "../../images/save-icon-white.png"
                        : "./images/save-icon-white.png"
                    }
                  />
                  Save
                </button>
              </div>
            </form>
          );
        }}
      </Formik>
    </>
  );
};
